import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  params: any;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  params: {}
};

export const chargeCreateDialogReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CHARGE_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_CHARGE_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_CHARGE_CREATE_FAILURE:
      const chargeFields: string[] = [];

      if (action.payload?.err.fields.includes("invoiceDate")) {
        chargeFields.push("invoiceDateForCharge");
      }

      if (action.payload?.err.fields.includes("invoiceNumber")) {
        chargeFields.push("invoiceNumberForCharge");
      }

      if (action.payload?.err.fields.includes("amount")) {
        chargeFields.push("amountForCharge");
      }

      if (action.payload?.err.fields.includes("currency")) {
        chargeFields.push("currencyIdForCharge");
      }

      if (action.payload?.err.fields.includes("vat")) {
        chargeFields.push("vatForCharge");
      }

      if (action.payload?.err.fields.includes("type")) {
        chargeFields.push("typeIdForCharge");
      }

      if (action.payload?.err.fields.includes("contactId")) {
        chargeFields.push("selectedPersonForCharge");
        chargeFields.push("counterpartyId");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        chargeFields.push("selectedCompanyForCharge");
        chargeFields.push("counterpartyId");
      }

      if(action.payload?.err.fields.includes("objectId")) {
        chargeFields.push("objectId")
      }

      if (action.payload?.err.message === "Charge requires at least one relation"
          || (action.payload?.err.fields.indexOf("propertyId") > -1 &&
              action.payload?.err.fields.indexOf("unitId") > -1 &&
                action.payload?.err.fields.indexOf("contractId") > -1)) {
        chargeFields.push("objectId");
      }

      if (action.payload?.err.fields.includes("firstDate")) {
        chargeFields.push("firstDateForCharge");
      }

      if (action.payload?.err.fields.includes("dateOfPeriod")) {
        chargeFields.push("dateOfPeriodForCharge");
      }

      if (action.payload?.err.fields.includes("description")) {
        chargeFields.push("descriptionForCharge");
      }
      
      return {
        ...state,
        isFetching: false,
        fields: chargeFields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CHARGE_CREATE_ADD_PARAMS:
      return {
        ...state,
        params: action.payload
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
      };
      
    case Constants.GLOBAL_CHARGE_CREATE_CLEAR:
    case Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
    case Constants.COACH_ERRORS_CLEAR:

      return {
        ...initialState
      };

    default:
      return state;
  }
};
